// src/features/users/hooks/useUserValidation.ts

import { useTranslate } from 'react-admin';
import { UserFormData, UserValidationErrors } from '../types';

export const useUserValidation = () => {
  const translate = useTranslate();

  const validateName = (value?: string): string | undefined => {
    if (!value || value.trim().length < 2) {
      return 'El nombre es obligatorio y debe tener al menos 2 caracteres';
    }
    return undefined;
  };

  const validateEmail = (value?: string): string | undefined => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value || !emailRegex.test(value)) {
      return 'Introduce un email válido';
    }
    return undefined;
  };

  const validatePassword = (value?: string): string | undefined => {
    if (!value || value.length < 8) {
      return 'La contraseña es obligatoria y debe tener al menos 8 caracteres';
    }
    return undefined;
  };
  
  const validateRoleAssignment = (data: UserFormData): Partial<UserValidationErrors> => {
    const errors: Partial<UserValidationErrors> = {};
    if ((data.role === 'HotelAdmin' || data.role === 'Receptionist') && !data.hotelId) {
      errors.hotelId = 'Se debe asignar un hotel para este rol.';
    }
    if (data.role === 'GroupAdmin' && !data.groupId) {
      errors.groupId = 'Se debe asignar un grupo para este rol.';
    }
    return errors;
  }

  const validateForm = (data: UserFormData, isCreate = false): UserValidationErrors => {
    const errors: UserValidationErrors = {};
    
    const nameError = validateName(data.name);
    if (nameError) errors.name = nameError;

    const emailError = validateEmail(data.email);
    if (emailError) errors.email = emailError;

    if (isCreate) {
      const passwordError = validatePassword(data.password);
      if (passwordError) errors.password = passwordError;
    }

    const assignmentErrors = validateRoleAssignment(data);
    Object.assign(errors, assignmentErrors);

    return errors;
  };

  return { validateName, validateEmail, validatePassword, validateForm };
};